import { defineRoute } from "../../common/route.common";
import { loadView } from "../../common/view.common";

export const FinanceAccountRoutes = defineRoute({
    record: {
        route: {
            path: "/finance-account",
            component: () => loadView(import("./FinanceAccountTable.vue")),
        },
    },
    create: {
        route: {
            path: "/finance-account/create",
            component: () => loadView(import("./FinanceAccountCreate.vue")),
        },
    },
    update: {
        route: {
            path: "/finance-account/update/:id",
            component: () => loadView(import("./FinanceAccountUpdate.vue")),
        },
        build(id: string) {
            return `/finance-account/update/${id}`;
        },
    },
});
